import React from "react"
import { Layer, Source, LineLayer } from "react-map-gl"
import { Coord } from "../lib/helpers/map"
import { LinePaint } from "./GeoJSONLayer"

interface LineLayout {
  lineCap?: "butt" | "round" | "square"
  lineJoin?: "bevel" | "round" | "miter"
}

interface PolylineLayerProps {
  id: string
  points: Coord[]
  paint?: LinePaint
  layout?: LineLayout
  properties?: any
  addBorder?: boolean
  borderColor?: string
  beforeId?: string
}

export const POLYLINE_LAYER_SUFFIX = "_polyline_layer"

const PolylineLayer: React.FC<PolylineLayerProps> = ({
  id,
  points,
  paint,
  layout,
  properties,
  addBorder,
  borderColor,
  beforeId,
}) => {
  const data = {
    type: "Feature",
    properties: properties ?? {},
    geometry: {
      type: "LineString",
      coordinates: points,
    },
  } as GeoJSON.Feature

  const lineLayer: LineLayer = {
    id: `${id}${POLYLINE_LAYER_SUFFIX}`,
    type: "line",
    paint: {
      "line-color": paint?.lineColor ?? "#000",
      "line-width": paint?.lineWidth ?? 1,
      "line-opacity": paint?.lineOpacity ?? 1,
      "line-dasharray": paint?.lineDasharray ?? [1],
    },
    layout: {
      "line-cap": layout?.lineCap ?? "square",
      "line-join": layout?.lineJoin ?? "round",
    },
  }

  const borderLayer: LineLayer = {
    id: `${id}${POLYLINE_LAYER_SUFFIX}_border`,
    type: "line",
    paint: {
      "line-color": borderColor ?? paint?.lineColor ?? "#000",
      "line-width": paint?.lineWidth ? paint?.lineWidth + 1 : 2,
      "line-opacity": paint?.lineOpacity ?? 1,
      "line-dasharray": paint?.lineDasharray ?? [1],
    },
    layout: {
      "line-cap": layout?.lineCap ?? "square",
      "line-join": layout?.lineJoin ?? "round",
    },
  }

  return (
    <Source type="geojson" data={data}>
      {addBorder && <Layer {...(beforeId ? { beforeId } : {})} {...borderLayer} />}
      <Layer {...(beforeId ? { beforeId } : {})} {...lineLayer} />
    </Source>
  )
}

export default PolylineLayer
